// chooseUs.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './chooseUs.css';

const ChooseUs = () => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState({ hours: 24, minutes: 0, seconds: 0 });
  const [isVisible, setIsVisible] = useState(false);

  // Simulated countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    // Set initial visibility after a short delay
    setTimeout(() => {
      setIsVisible(true);
    }, 500);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : time;
  };

  const handleUnlockNow = () => {
    navigate('/pricing');
  };

  return (
    <div className={`choose-us-container ${isVisible ? 'visible' : ''}`}>
      <div className="choose-us-badge">
        <span className="choose-us-pulse-dot"></span>
        <span>Limited Time Offer</span>
      </div>

      <div className="choose-us-hero-section">
        <h1 className="choose-us-hero-title">
          Never <span className="choose-us-highlight">Struggle With Dating Texts</span> Again
        </h1>
        
        <div className="choose-us-subtitle">
          Join thousands who are getting more dates, better conversations, and deeper connections
        </div>

        <div className="choose-us-stats-grid">
          <div className="choose-us-stat-card">
            <div className="choose-us-stat-value">3.4x</div>
            <div className="choose-us-stat-label">Higher Response Rate</div>
          </div>
          <div className="choose-us-stat-card">
            <div className="choose-us-stat-value">89%</div>
            <div className="choose-us-stat-label">Success Rate</div>
          </div>
          <div className="choose-us-stat-card">
            <div className="choose-us-stat-value">50K+</div>
            <div className="choose-us-stat-label">Active Users</div>
          </div>
        </div>

        <button className="choose-us-hero-cta" onClick={handleUnlockNow}>
          Unlock Your Potential Now - 50% Off <span className="choose-us-arrow">→</span>
        </button>
      </div>

      <div className="choose-us-how-it-works">
        <h2 className="choose-us-section-title">How RizzologyGPT Works</h2>
        
        <div className="choose-us-steps">
          <div className="choose-us-step">
            <div className="choose-us-step-number">1</div>
            <div className="choose-us-step-content">
              <h3>Paste Your Conversation</h3>
              <p>Share the message you received from your date</p>
            </div>
          </div>
          
          <div className="choose-us-step-arrow">→</div>
          
          <div className="choose-us-step">
            <div className="choose-us-step-number">2</div>
            <div className="choose-us-step-content">
              <h3>AI Analyzes</h3>
              <p>Our AI understands the context and tone</p>
            </div>
          </div>
          
          <div className="choose-us-step-arrow">→</div>
          
          <div className="choose-us-step">
            <div className="choose-us-step-number">3</div>
            <div className="choose-us-step-content">
              <h3>Get Perfect Replies</h3>
              <p>Choose from multiple engaging responses</p>
            </div>
          </div>
        </div>
      </div>

      <div className="choose-us-features-section">
        <h2 className="choose-us-section-title">Why Users Love RizzologyGPT</h2>
        
        <div className="choose-us-features-grid">
          <div className="choose-us-feature-card">
            <div className="choose-us-feature-icon">🔮</div>
            <h3>Personalized Replies</h3>
            <p>AI learns your style and adapts to match your personality</p>
          </div>

          <div className="choose-us-feature-card premium">
            <div className="choose-us-limited-tag">Most Popular</div>
            <div className="choose-us-feature-icon">⚡</div>
            <h3>Instant Results</h3>
            <p>Get immediate suggestions backed by proven psychology</p>
          </div>

          <div className="choose-us-feature-card">
            <div className="choose-us-feature-icon">🔒</div>
            <h3>Privacy First</h3>
            <p>Your conversations stay completely private and secure</p>
          </div>
          
          <div className="choose-us-feature-card">
            <div className="choose-us-feature-icon">🎯</div>
            <h3>High Success Rate</h3>
            <p>89% of users report more dates and better connections</p>
          </div>
          
          <div className="choose-us-feature-card">
            <div className="choose-us-feature-icon">🛠️</div>
            <h3>Customizable Tone</h3>
            <p>Adjust how playful, serious, or flirty your responses are</p>
          </div>
          
          <div className="choose-us-feature-card">
            <div className="choose-us-feature-icon">🚀</div>
            <h3>24/7 Availability</h3>
            <p>Get help with your texts anytime, day or night</p>
          </div>
        </div>
      </div>

      <div className="choose-us-social-proof">
        <h2 className="choose-us-section-title">Success Stories</h2>
        
        <div className="choose-us-testimonials">
          <div className="choose-us-testimonial">
            <div className="choose-us-avatar">JD</div>
            <p>"I was always overthinking my messages. RizzologyGPT gave me the confidence to be myself, and I'm now dating someone amazing!"</p>
            <div className="choose-us-user-info">
              <span className="choose-us-name">James D.</span>
              <span className="choose-us-rating">⭐⭐⭐⭐⭐</span>
            </div>
          </div>
          
          <div className="choose-us-testimonial">
            <div className="choose-us-avatar">SM</div>
            <p>"Found my perfect match within 2 weeks of using RizzologyGPT! The responses were clever and showed my best side."</p>
            <div className="choose-us-user-info">
              <span className="choose-us-name">Sarah M.</span>
              <span className="choose-us-rating">⭐⭐⭐⭐⭐</span>
            </div>
          </div>
          
          <div className="choose-us-testimonial">
            <div className="choose-us-avatar">TK</div>
            <p>"I was stuck in a conversation that was going nowhere. One suggestion from RizzologyGPT completely turned things around!"</p>
            <div className="choose-us-user-info">
              <span className="choose-us-name">Thomas K.</span>
              <span className="choose-us-rating">⭐⭐⭐⭐⭐</span>
            </div>
          </div>
        </div>
      </div>

      <div className="choose-us-cta-section">
        <div className="choose-us-timer">
          <div className="choose-us-timer-label">Special 50% Discount Ends In:</div>
          <div className="choose-us-countdown">
            <span>{formatTime(timeLeft.hours)}</span>:
            <span>{formatTime(timeLeft.minutes)}</span>:
            <span>{formatTime(timeLeft.seconds)}</span>
          </div>
        </div>
        
        <div className="choose-us-pricing-info">
          <div className="choose-us-price-tag">
            <span className="choose-us-original-price">R299</span>
            <span className="choose-us-new-price">R149</span>
            <span className="choose-us-per-month">/month</span>
          </div>
        </div>
        
        <div className="choose-us-cta-buttons">
          <button className="choose-us-cta-button primary full-width" onClick={handleUnlockNow}>
            Unlock Your Potential Now <span className="choose-us-arrow">→</span>
          </button>
        </div>
        
        <div className="choose-us-guarantee">
          <span className="choose-us-guarantee-icon">🔄</span>
          30-Day Money-Back Guarantee • No Questions Asked
        </div>
      </div>
      
      <div className="choose-us-sticky-cta">
        <div className="choose-us-sticky-timer">
          {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
        </div>
        <button onClick={handleUnlockNow}>
          Get 50% Off <span className="choose-us-arrow">→</span>
        </button>
      </div>
    </div>
  );
};

export default ChooseUs;
